import { OrderItemDataFragment, Enum_Orderitemaction_Action } from "data";
import { PowerOnIcon } from "components/Icons";
import { ActionComponent, ActionComponentVariant } from "components/ActionComponent";
import { useRegisterOrderItemAction } from "features/order-items/data/hooks/order-item-actions";

interface ReplacePSUFanActionProps {
  orderItem: OrderItemDataFragment;
  variant: ActionComponentVariant;
}

export const ReplacePSUFanAction = (props: ReplacePSUFanActionProps) => {
  const { orderItem, variant } = props;
  const { registerAction } = useRegisterOrderItemAction();
  return (
    <ActionComponent
      action={async () => {
        if (orderItem.id) {
          await registerAction({
            orderItem,
            action: {
              action: Enum_Orderitemaction_Action.ReplacePsuFan,
            },
          });
        }
      }}
      variant={variant}
      actionIcon={<PowerOnIcon />}
      actionLabel='Replace PSU Fan'
      data-cy='action-replace-psu-fan'
    />
  );
};

ReplacePSUFanAction.defaultProps = {
  variant: "menu-item",
};
